"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dropdownButton = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _zIndex = _interopRequireDefault(require("../choices/zIndex.const"));

var _button = require("./button.const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dropdownButton = {
  button: Object.assign({}, _button.button),
  indicatorLeftMargin: _size["default"]["default"],
  indicatorScale: 1,
  indicatorColor: _color["default"].steel700,
  indicatorColorDisabled: _color["default"].cloudyBlue,
  dropdownOffset: '0',
  dropdownMaxHeight: '200px',
  dropdownMaxWidth: '200px',
  dropdownPadding: "".concat(_spacing["default"].xxs, " ").concat(_spacing["default"].sm, " ").concat(_spacing["default"].xxs, " 0"),
  dropdownBackgroundColor: _color["default"].white,
  dropdownBorderColor: _color["default"].cloudyBlue300,
  dropdownShadowSize: _size["default"].shadowDefault,
  dropdownShadowColor: _color["default"].cloudyBlue300,
  dropdownZIndex: _zIndex["default"].z3000
};
exports.dropdownButton = dropdownButton;
var _default = dropdownButton;
exports["default"] = _default;